import styled from '@emotion/styled';

export const Root = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex: 1;
  overflow: hidden;
  flex-direction: column;
`;
